import { connectMediaStore } from './withOwnReduxStore';
import { getCurrentGallectionSubfolders, getCurrentSubfolderId } from '../selectors';
const mapStateToProps = (state)=>({
        subfolders: getCurrentGallectionSubfolders(state),
        currentSubfolderId: getCurrentSubfolderId(state)
    });
export default connectMediaStore(mapStateToProps);

//# sourceMappingURL=withCurrentGallectionSubfolders.js.map